import {Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, QueryList, SimpleChanges, ViewChildren} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import dayjs from "dayjs";
import { Subscription, catchError, throwError } from 'rxjs';
import { BackToSeasonManagerComponent } from 'src/app/dialogs/season-manager-dialogs/back-to-season-manager/back-to-season-manager.component';
import { CreateEditSeasonComponent } from 'src/app/dialogs/season-manager-dialogs/create-edit-season/create-edit-season.component';
import { SeasonFieldBaseDto } from 'src/app/dto/season-dto/season-field-base-dto';
import { SeasonFieldFruitDto } from 'src/app/dto/season-dto/season-field-fruit-dto';
import { SeasonFieldGrainFeedDto } from 'src/app/dto/season-dto/season-field-grain-feed-dto';
import { SeasonFieldVegatablesDto } from 'src/app/dto/season-dto/season-field-vegetables-dto';
import { SeasonFieldVineyardDto } from 'src/app/dto/season-dto/season-field-vineyard-dto';
import { SeasonDetailsModel } from 'src/app/models/season-details-model';
import { SeasonMetaDataCombinedModel } from 'src/app/models/season-models/season-meta-data-combined-model';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { SeasonManagerService } from 'src/app/services/season-manager.service';
import { SeasonSharedDataService } from 'src/app/services/season-shared-data.service';
import { SeasonFieldInputComponent } from '../season-field-input/season-field-input.component';
import { SeasonFullModel } from 'src/app/models/season-models/season-full-model';
import { TenantService } from 'src/app/services/tenant.service';
import { FormControl, FormGroup } from '@angular/forms';
import { LinkFieldToSeasonComponent } from 'src/app/dialogs/season-manager-dialogs/link-field-to-season/link-field-to-season.component';
import { SaveLinkDataComponent } from 'src/app/dialogs/season-manager-dialogs/save-link-data/save-link-data.component';
import { SeasonDetailFieldModel } from 'src/app/models/season-models/season-detail-field-model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ExstraDetailModel } from 'src/app/models/season-models/exstra-detail-model';
import { BoundaryManagementService } from 'src/app/services/boundary-management.service';
import {SeasonDropdownModel} from "../../models/season-models/season-dropdown-model";
import { DraftConfirmationDialogComponent } from 'src/app/dialogs/draft-confirmation-dialog/draft-confirmation-dialog.component';
import { SeasonFieldBase } from '../../dto/season-dto/season-field-base';

@Component({
    selector: 'app-edit-field-link-season',
    templateUrl: './edit-field-link-season.component.html',
    styleUrls: ['./edit-field-link-season.component.css'],
    standalone: false
})
export class EditFieldLinkSeasonComponent implements OnInit, OnDestroy, OnChanges {

  linkFieldForm: FormGroup;

  @Input() fieldIdInput: number = null;
  @Input() inlineMode: boolean = false;
  @Input() panelTab: 'field' | 'crop' | 'cost' | null = null;
  @Output() seasonDataLoaded = new EventEmitter<any>();
  @Output() fieldNameUpdated = new EventEmitter<string>();

  @ViewChildren(SeasonFieldInputComponent) seasoinFieldInput: QueryList<SeasonFieldInputComponent>;

  seasonFormData: SeasonDetailFieldModel = null;
  seasonFormExtraData: ExstraDetailModel = null;  seasons: SeasonDropdownModel[] = [];
  private seasonMetaDataDetails: SeasonMetaDataCombinedModel;
  seasonFarmFieldsData: any = null;
  subscriptions: Subscription[] = [];
  fieldAdminStyle = {
    'padding': '0 30px'
  }

  protected readonly dayjs = dayjs;

  placeholder: string = '-';
  dateStringFormatting = 'YYYY-MM-DD';
  fieldName: string = '-';

  private routeSub: Subscription;

  fieldId: number = 0;
  tenantId: number = 0;
  seasonId: number = 0;
  containerHeight: string = '';
  isInAnotherActiveSeason: boolean = false;
  isCallDone: boolean = false;
  selectedDefinitionIndex: number = 0;

  /**
   * Mirrors selectedDefinitionIndex, but only updates once a tab change is
   * accepted. The template's [(selectedIndex)] two-way binding moves
   * selectedDefinitionIndex before (selectedIndexChange) fires, so this is the
   * only reliable reference to the definition being left.
   */
  private previousDefinitionIndex: number = 0;

  /**
   * True while this definition's cultivar size would push the field over its
   * total. Blocks the definition tabs and Add Definition, both of which save.
   */
  cultivarSizeInvalid: boolean = false;

  /** Cultivar size rejection from the API, rendered on the input by the child. */
  cultivarSizeServerError: string = null;
  private isTabSwitching: boolean = false;

  get currentDefinition(): SeasonFieldBase {
    if (this.seasonFormData?.details?.length > 0) {
      return this.seasonFormData.details[this.selectedDefinitionIndex] || this.seasonFormData.detail;
    }
    return this.seasonFormData?.detail;
  }

  constructor(
    private router: Router,
    public nav: NavBarComponent,
    private seasonManagerService: SeasonManagerService,
    private seasonSharedDataService: SeasonSharedDataService,
    public matDialog: MatDialog,
    private route: ActivatedRoute,
    private tenantService: TenantService
  ) {
    // this.seasonSharedDataService.seasonInputFormData$.subscribe(data => {
    //   this.seasonFormData = data;
    // });

    this.linkFieldForm = new FormGroup({
      season: new FormControl(null),
    });

  }

  ngOnInit(): void {

    this.seasonFarmFieldsData = this.seasonSharedDataService.getSeasonFarmFieldsDataData();

    if (this.fieldIdInput) {
      this.fieldId = this.fieldIdInput;
    } else {
      this.routeSub = this.route.params.subscribe(params => {
        this.fieldId = params['id'];
      });
    }


    this.subscriptions.push(this.tenantService.currenttenantId.subscribe(tenantId => {
      if (tenantId) {
        this.tenantId = Number(tenantId);
        this.populateSeasonDropdownList();

      } else if (!tenantId && sessionStorage.getItem("selectedTenant") !== null) {
        this.tenantId = Number(sessionStorage.getItem("selectedTenant"));
        this.populateSeasonDropdownList();
      }
    }));
    if (!this.fieldIdInput) {
      this.routeSub = this.route.params.subscribe(params => {
        this.fieldId = params['id'];
      });
    }
    this.populateSeasonDropdownDetails();
    this.populateDetailField();
    this.seasonSharedDataService.updateIsHiddenData(false);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fieldIdInput'] && !changes['fieldIdInput'].firstChange && this.fieldIdInput) {
      this.fieldId = this.fieldIdInput;
      this.isCallDone = false;
      this.selectedDefinitionIndex = 0;
      this.previousDefinitionIndex = 0;
      this.seasonFormExtraData = null;
      this.populateDetailField();
    }
  }

  onFormDataChange(data: any) {
    // Tracked outside the guards below so the blocks never go stale.
    this.cultivarSizeInvalid = !!data?.name?.controls?.cultivarSize?.hasError('cultivarSizeSum');

    if (data && !data.isFormPopulating && !this.isTabSwitching) {
      if (this.seasonFormData.details?.length > 0) {
        const existing = this.seasonFormData.details[this.selectedDefinitionIndex];
        const updatedFieldName = data.value.fieldName ?? existing?.fieldName;
        const updated = {
          ...data.value,
          id: existing?.id,
          fieldId: existing?.fieldId,
          fieldName: updatedFieldName,
          fieldSize: existing?.fieldSize,
          fieldType: data.value.fieldTypeId ?? existing?.fieldType,
          currentCrop: data.value.currentCropId ?? existing?.currentCrop,
          irrigationType: data.value.irrigationTypeId ?? existing?.irrigationType,
        };
        this.seasonFormData.details[this.selectedDefinitionIndex] = updated;

        // fieldName is a field-level property — propagate to all definitions
        if (updatedFieldName != null) {
          this.seasonFormData.details.forEach((def: any, i: number) => {
            if (i !== this.selectedDefinitionIndex) {
              def.fieldName = updatedFieldName;
            }
          });
        }
      }
      this.seasonFormData.detail = this.seasonFormData.details?.[0] || data.value;
    }
  }

  openSaveLinkFieldDetailsDialog() {
    const dialogRef = this.matDialog.open(SaveLinkDataComponent, {
      data: {
        seasonId: 344,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.option == 'save') {
        this.saveSeasonDetails();
      }
    });
  }


  openBackDialog() {
    const dialogRef = this.matDialog.open(DraftConfirmationDialogComponent, {
      data: {
        dialogType: 'back',
        dialogTitle: 'GO BACK?',
        dialogSubTitle: 'Unsaved changes will be lost, are you sure?'
      }
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.router.navigate(['/season-manager/fields']);
      }
    });

    
  }


  populateDetailField() {
    this.nav.toggleLoading(true);

    this.seasonManagerService.getDetailsOfFieldById(Number(this.fieldId)).pipe(
      catchError(error => {
        console.error();
        this.isCallDone = true;
        return throwError(() => error);
      })
    ).subscribe((response) => {
      this.seasonFormData = response;
      if (this.inlineMode && response?.season) {
        this.seasonDataLoaded.emit(response.season);
      }

      if(!this.seasonFormData.detail) {
        this.seasonFormData.detail = {
          fieldName: this.seasonFormData.field.name,
          allowNotifications: this.seasonFormData.field.allowNotifications,
          fieldSize: this.seasonFormData.field.fieldSize
        }
      }
      // Ensure details array exists
      if (!this.seasonFormData.details || this.seasonFormData.details.length === 0) {
        this.seasonFormData.details = this.seasonFormData.detail ? [this.seasonFormData.detail] : [];
      } else {
        this.seasonFormData.details[0] = this.seasonFormData.detail;
      }

      // Resolve active definition index
      const activeIdx = this.seasonFormData.details.findIndex((d: any) => d.isSelectedCropDefinition === true || d.isActive === true);
      this.selectedDefinitionIndex = activeIdx > -1 ? activeIdx : 0;
      this.previousDefinitionIndex = this.selectedDefinitionIndex;
      // this.validateLinkFormControls();

      this.isInAnotherActiveSeason = this.seasonFormData.field.isInAnotherActiveSeason;
      this.seasonSharedDataService.updateSeasonDetailBaseData(this.seasonFormData);
      this.seasonSharedDataService.updateIsDisabledData(this.isInAnotherActiveSeason);

      if (this.seasonFormData?.detail?.fieldType) {
        this.populateExtraDetail();
      } else {
        this.isCallDone = true;
        this.nav.toggleLoading(false);
      }
    });

  }


  populateExtraDetail() {
    this.nav.toggleLoading(true);
 
    let detailId = this.seasonFormData.detail.id;
    let fieldTypeId = this.seasonFormData.detail.fieldType ?? null;

    this.seasonManagerService.getSeasonDetailExtraData(detailId, Number(fieldTypeId)).pipe(
      catchError(error => {
        console.error();
        this.isCallDone = true;
        return throwError(() => error);
      })
    ).subscribe((response) => {

      this.seasonFormExtraData = response;

      this.seasonSharedDataService.updateSeasonDetailExtraData(this.seasonFormExtraData);
      this.isCallDone = true;

      this.nav.toggleLoading(false);
    });

  }

  populateSeasonDropdownDetails() {
    this.nav.toggleLoading(true);

    this.seasonManagerService.getSeasonMetaData().pipe(
      catchError(error => {
        console.error();
        return throwError(() => error);
      })
    ).subscribe((response) => {
      this.seasonMetaDataDetails = response;

      if (this.seasonMetaDataDetails == null) {
        return;
      }
      this.seasonSharedDataService.updateCombinedData(this.seasonMetaDataDetails);
      setTimeout(() => {
        this.nav.toggleLoading(false);
      }, 1400)

    });

  }

  populateSeasonDropdownList() {
    this.nav.toggleLoading(true);
    this.seasonManagerService.getSeasonsListForDropDown(this.tenantId).pipe(
      catchError(error => {
        console.error();
        return throwError(() => error);
      })
    ).subscribe((response) => {
      this.seasons = response;
      setTimeout(() => {
        this.nav.toggleLoading(false);
      }, 1400)

    });

  }

  saveSeasonDetails() {

    if (this.seasonFormData.season == null) {
      let newFieldBaseDetail = {
        fieldId: this.fieldId,
        fieldName: this.seasonSharedDataService.getSeasonFieldNameData(),
        allowNotification: this.seasonSharedDataService.getSeasonAllowNotificationData(),
      }

      if (newFieldBaseDetail.fieldName == null) {
        newFieldBaseDetail.fieldName = this.seasonFormData.field.name;
      }

      if (newFieldBaseDetail.allowNotification == null) {
        newFieldBaseDetail.allowNotification = false;
      }


      this.seasonManagerService.updateFieldNameAllowNotification(newFieldBaseDetail.fieldId, newFieldBaseDetail.fieldName, newFieldBaseDetail.allowNotification).subscribe((result) => {
        this.fieldNameUpdated.emit(newFieldBaseDetail.fieldName);
        this.refreshBrowser();

      });
    } else {

      if (this.currentDefinition !== null) {
        // Save ALL definitions, not just the active tab
        const definitions = this.seasonFormData.details?.length > 0 ? this.seasonFormData.details : [this.currentDefinition];
        
        // Emit the field name from the first definition (all should be the same)
        const updatedName = definitions[0]?.fieldName;
        if (updatedName) {
          this.fieldNameUpdated.emit(updatedName);
        }

        definitions.forEach((def: any) => {
          if (!def?.id) return;
          const fieldTypeId = def?.fieldTypeId ?? def?.fieldType;
          const seasonDetails = {
            ...def,
            fieldTypeId: fieldTypeId,
            currentCropId: def?.currentCropId ?? def?.currentCrop,
            irrigationTypeId: def?.irrigationTypeId ?? def?.irrigationType,
          };
          delete seasonDetails.fieldId;
          delete seasonDetails.id;
          delete seasonDetails.grainFeed;
          delete seasonDetails.vegetables;
          delete seasonDetails.vineyard;
          delete seasonDetails.fruit;

          this.seasonManagerService.updateSeasonFieldBaseDetails(def.id, seasonDetails).subscribe(response => {
          }, error => {
          });

          if (fieldTypeId == 1 && def.grainFeed) {
            this.seasonManagerService.postSeasonDetailsGrainFeed(def.id, def.grainFeed).subscribe(response => {
            }, error => {
            });
          }

          if (fieldTypeId == 2 && def.vegetables) {
            this.seasonManagerService.postSeasonDetailsVegetables(def.id, def.vegetables).subscribe(response => {
            }, error => {
            });
          }

          if (fieldTypeId == 3 && def.vineyard) {
            this.seasonManagerService.postSeasonDetailsVineyard(def.id, def.vineyard).subscribe(response => {
            }, error => {
            });
          }

          if (fieldTypeId == 4 && def.fruit) {
            this.seasonManagerService.postSeasonDetailsFruit(def.id, def.fruit).subscribe(response => {
            }, error => {
            });
          }
        });

        this.nav.toggleLoading(false);
      }

      this.seasonFormData.detail = this.seasonFormData.details?.[0] || this.currentDefinition;
    }

  }

  refreshBrowser() {
    // FORCE REFRESH BROWSER
    this.router.navigateByUrl("/season-manager/fields", { skipLocationChange: true }).then(() => {
      this.router.navigate([`/field-admin/edit-link-field/${this.fieldId}`]);
    });
  }

  private saveCurrentDefinitionSilently(definitionIndex: number) {
    const def: any = this.seasonFormData?.details?.[definitionIndex];
    if (!def?.id) return;

    const fieldTypeId = def?.fieldTypeId ?? def?.fieldType;
    const seasonDetails = {
      ...def,
      isSelectedCropDefinition: false,
      fieldTypeId: fieldTypeId,
      currentCropId: def?.currentCropId ?? def?.currentCrop,
      irrigationTypeId: def?.irrigationTypeId ?? def?.irrigationType,
    };
    delete seasonDetails.fieldId;
    delete seasonDetails.id;
    delete seasonDetails.grainFeed;
    delete seasonDetails.vegetables;
    delete seasonDetails.vineyard;
    delete seasonDetails.fruit;

    this.seasonManagerService.updateSeasonFieldBaseDetails(def.id, seasonDetails).subscribe();

    if (fieldTypeId == 1 && def.grainFeed) {
      this.seasonManagerService.postSeasonDetailsGrainFeed(def.id, def.grainFeed).subscribe();
    }
    if (fieldTypeId == 2 && def.vegetables) {
      this.seasonManagerService.postSeasonDetailsVegetables(def.id, def.vegetables).subscribe();
    }
    if (fieldTypeId == 3 && def.vineyard) {
      this.seasonManagerService.postSeasonDetailsVineyard(def.id, def.vineyard).subscribe();
    }
    if (fieldTypeId == 4 && def.fruit) {
      this.seasonManagerService.postSeasonDetailsFruit(def.id, def.fruit).subscribe();
    }
  }

  onDefinitionTabChange(index: number) {
    // [(selectedIndex)] has already moved selectedDefinitionIndex to the new
    // tab by the time this runs, so the definition being left must come from
    // previousDefinitionIndex.
    const previousIndex = this.previousDefinitionIndex;

    // Backstop for the disabled tabs: the auto-save below must never persist
    // an invalid cultivar size.
    if (this.cultivarSizeInvalid && index !== previousIndex) {
      setTimeout(() => this.selectedDefinitionIndex = previousIndex);
      return;
    }

    // Auto-save the definition being left — not the one being switched to.
    this.saveCurrentDefinitionSilently(previousIndex);
    this.isTabSwitching = true;
    this.selectedDefinitionIndex = index;
    this.previousDefinitionIndex = index;
    // Update isSelectedCropDefinition flags in-memory
    const defs = this.seasonFormData?.details || [];
    defs.forEach((d: any, i: number) => d.isSelectedCropDefinition = (i === index));
    // Mark new definition as selected and persist
    const newDef = this.seasonFormData?.details?.[index];
    if (newDef?.id) {
      this.seasonManagerService.updateSeasonFieldBaseDetails(newDef.id, { isSelectedCropDefinition: true }).subscribe();
    }
    // Clear stale extra detail data before fetching new definition's data to prevent
    // the child component from reading the previous definition's crop-specific values.
    this.seasonFormExtraData = null;
    this.populateExtraDetailForDefinition(this.currentDefinition);
    setTimeout(() => this.isTabSwitching = false, 0);
  }

  getDefinitionLabel(def: SeasonFieldBase, index: number): string {
    return def?.cultivar || `Definition ${index + 1}`;
  }

  addDefinition() {
    const seasonId = this.seasonFormData.season?.id;
    if (!seasonId) return;

    const dialogRef = this.matDialog.open(DraftConfirmationDialogComponent, {
      data: { dialogType: 'save', dialogTitle: 'Save Changes', dialogSubTitle: 'All current changes will be saved before creating a new definition.' }
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return;
      this.saveAllDefinitions(() => {
        const currentDef = this.seasonFormData.details[this.selectedDefinitionIndex];
        this.seasonManagerService.addDefinition(seasonId, this.fieldId, currentDef).subscribe((newDef) => {
          newDef.fieldName = this.seasonFormData.details[0]?.fieldName ?? this.seasonFormData.field?.name;
          newDef.allowNotifications = this.seasonFormData.details[0]?.allowNotifications;
          newDef.fieldSize = this.seasonFormData.details[0]?.fieldSize;
          if (typeof newDef.fieldType === 'object' && newDef.fieldType) newDef.fieldType = (newDef.fieldType as any).id;
          if (typeof newDef.currentCrop === 'object' && newDef.currentCrop) newDef.currentCrop = (newDef.currentCrop as any).id;
          if (typeof newDef.irrigationType === 'object' && newDef.irrigationType) newDef.irrigationType = (newDef.irrigationType as any).id;
          this.seasonFormData.details.push(newDef);
          this.selectedDefinitionIndex = this.seasonFormData.details.length - 1;
          this.previousDefinitionIndex = this.selectedDefinitionIndex;
          this.populateExtraDetailForDefinition(newDef);
        });
      });
    });
  }

  /**
   * Pulls the message out of a 400 from the cultivar size check. Read
   * defensively: PG-358 throws a ResponseStatusException giving Spring's
   * default body, while the architecture document specifies a structured
   * shape. Anything else is ignored, so unrelated failures are not shown
   * against this field.
   */
  private extractCultivarSizeError(err: any): string | null {
    if (err?.status !== 400) return null;
    const body = err?.error;
    const message = typeof body === 'string' ? body : body?.message;
    if (typeof message === 'string' && message.toLowerCase().includes('cultivar size')) {
      return message;
    }
    return null;
  }

  private saveAllDefinitions(onComplete?: () => void) {
    const definitions = this.seasonFormData.details?.length > 0 ? this.seasonFormData.details : [];
    let remaining = definitions.length;
    if (remaining === 0) { if (onComplete) onComplete(); return; }

    definitions.forEach((def: any) => {
      if (!def?.id) { remaining--; if (remaining === 0 && onComplete) onComplete(); return; }
      const fieldTypeId = def?.fieldTypeId ?? def?.fieldType;
      const seasonDetails = {
        ...def,
        fieldTypeId: fieldTypeId,
        currentCropId: def?.currentCropId ?? def?.currentCrop,
        irrigationTypeId: def?.irrigationTypeId ?? def?.irrigationType,
      };
      ['fieldId', 'id', 'grainFeed', 'vegetables', 'vineyard', 'fruit'].forEach(key => delete seasonDetails[key]);

      this.seasonManagerService.updateSeasonFieldBaseDetails(def.id, seasonDetails).subscribe(() => {
        this.cultivarSizeServerError = null;
        remaining--;
        if (remaining === 0 && onComplete) onComplete();
      }, (err: any) => {
        const message = this.extractCultivarSizeError(err);
        if (message) this.cultivarSizeServerError = message;
        remaining--;
        if (remaining === 0 && onComplete) onComplete();
      });

      // Save crop detail (extra details)
      if (fieldTypeId == 1 && def.grainFeed) {
        this.seasonManagerService.postSeasonDetailsGrainFeed(def.id, def.grainFeed).subscribe();
      }
      if (fieldTypeId == 2 && def.vegetables) {
        this.seasonManagerService.postSeasonDetailsVegetables(def.id, def.vegetables).subscribe();
      }
      if (fieldTypeId == 3 && def.vineyard) {
        this.seasonManagerService.postSeasonDetailsVineyard(def.id, def.vineyard).subscribe();
      }
      if (fieldTypeId == 4 && def.fruit) {
        this.seasonManagerService.postSeasonDetailsFruit(def.id, def.fruit).subscribe();
      }
    });
  }

  deleteDefinition(def: SeasonFieldBase, event: Event) {
    event.stopPropagation();
    if (this.seasonFormData.details.length <= 1) return;

    const dialogRef = this.matDialog.open(DraftConfirmationDialogComponent, {
      data: { dialogType: 'delete', dialogTitle: 'Delete Definition', dialogSubTitle: 'Are you sure you want to delete this crop definition?' }
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return;
      this.seasonManagerService.deleteDefinition(def.id).subscribe(() => {
        this.seasonFormData.details = this.seasonFormData.details.filter(d => d.id !== def.id);
        if (this.selectedDefinitionIndex >= this.seasonFormData.details.length) {
          this.selectedDefinitionIndex = this.seasonFormData.details.length - 1;
          this.previousDefinitionIndex = this.selectedDefinitionIndex;
        }
        this.seasonFormData.detail = this.seasonFormData.details[0];
        this.populateExtraDetailForDefinition(this.currentDefinition);
      });
    });
  }

  populateExtraDetailForDefinition(def: SeasonFieldBase) {
    if (!def?.id || !def?.fieldType) {
      this.seasonFormExtraData = null;
      return;
    }
    const fieldTypeId = typeof def.fieldType === 'object' ? (def.fieldType as any).id : Number(def.fieldType);
    this.seasonManagerService.getSeasonDetailExtraData(def.id, fieldTypeId).pipe(
      catchError(error => {
        console.error();
        return throwError(() => error);
      })
    ).subscribe((response) => {
      this.seasonFormExtraData = response;
      this.seasonSharedDataService.updateSeasonDetailExtraData(this.seasonFormExtraData);
      // Force new object reference so ngOnChanges detects the input change
      this.seasonFormData = {...this.seasonFormData};
      this.seasonFormData.details[this.selectedDefinitionIndex] = {...def};
    });
  }


  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    })
  }

}
